import React from "react";
import "./style.scss";

const SlideBottomToTop = props => (
  <div className="slideTopContainer">{props.children}</div>
);

export default SlideBottomToTop;
